/**
 * B2B Registration Form Handler (Fallback-Seite /account/register)
 * Submits to Pimcore POST /api/b2b/register (public endpoint, no API key needed)
 * UID on-blur → GET /api/b2b/check-uid (duplicate check, stub returns exists=false)
 */
(function () {
  'use strict';

  const API_BASE = (window.b2bConfig && window.b2bConfig.apiBase) || 'https://pim.schaltschrank24.ch';

  function showMessage(text, type) {
    const el = document.getElementById('b2b-register-message');
    if (!el) return;
    el.textContent = text;
    el.style.display = 'block';
    el.style.background = type === 'success' ? '#d1fae5' : '#fee2e2';
    el.style.color      = type === 'success' ? '#065f46' : '#991b1b';
    el.style.border     = '1px solid ' + (type === 'success' ? '#6ee7b7' : '#fca5a5');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Firma bereits registriert (409 + code=company_already_registered):
  // Meldung + CTA "Einladungslink anfordern" statt Sackgasse. Baut die UI per
  // createElement (kein innerHTML → XSS-sicher) in den vorhandenen Meldungs-Container.
  function showCompanyExistsCTA(payload) {
    const el = document.getElementById('b2b-register-message');
    if (!el) return;
    el.textContent = '';
    el.style.display = 'block';
    el.style.background = '#fff7ed';
    el.style.color      = '#9a3412';
    el.style.border     = '1px solid #fdba74';

    const p = document.createElement('p');
    p.style.margin = '0 0 1rem';
    p.textContent = window.customStrings.inviteFirmExists;
    el.appendChild(p);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button';
    btn.textContent = window.customStrings.inviteRequestBtn;
    el.appendChild(btn);

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = window.customStrings.sending;
      fetch(API_BASE + '/api/b2b/request-invitation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firma:   payload.firma,
          uid:     payload.uid,
          email:   payload.email,
          name:    ((payload.vorname || '') + ' ' + (payload.nachname || '')).trim(),
          telefon: payload.telefon,
        }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          // Erfolg: Container auf grün, Button entfällt (clientseitiges Rate-Limit).
          el.textContent = '';
          el.style.background = '#d1fae5';
          el.style.color      = '#065f46';
          el.style.border     = '1px solid #6ee7b7';
          const done = document.createElement('p');
          done.style.margin = '0';
          done.textContent = (data && data.message)
            || window.customStrings.inviteThanks;
          el.appendChild(done);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = window.customStrings.inviteRequestBtn;
          const errp = document.createElement('p');
          errp.style.margin = '.8rem 0 0';
          errp.style.color = '#991b1b';
          errp.textContent = window.customStrings.reqFailed + window.customStrings.reqFailedContact;
          el.appendChild(errp);
        });
    });

    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setUidError(msg) {
    const el = document.getElementById('reg-uid-error');
    if (!el) return;
    el.textContent = msg || '';
    el.style.display = msg ? 'block' : 'none';
  }

  // ── Privatperson toggle ──────────────────────────────────────
  function setFieldDisabled(wrapId, inputEl, disabled) {
    if (!inputEl) return;
    inputEl.disabled = disabled;
    inputEl.required = !disabled;
    const wrap = document.getElementById(wrapId);
    if (wrap) wrap.style.display = disabled ? 'none' : '';
  }

  // Same as setFieldDisabled but never toggles `required` — for optional B2B fields.
  function setOptionalFieldDisabled(wrapId, inputEl, disabled) {
    if (!inputEl) return;
    inputEl.disabled = disabled;
    const wrap = document.getElementById(wrapId);
    if (wrap) wrap.style.display = disabled ? 'none' : '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    const form      = document.getElementById('b2b-register-form');
    if (!form) return;

    const uidInput        = document.getElementById('reg-uid');
    const emailInput      = document.getElementById('reg-email');
    const submitBtn       = document.getElementById('b2b-register-submit');
    const privateCheckbox = document.getElementById('reg-is-private');
    const firmaInput      = document.getElementById('reg-firma');
    const firmaEmailInput = document.getElementById('reg-firma-email');
    const rechnungInput   = document.getElementById('reg-rechnung-email');
    const abInput         = document.getElementById('reg-ab-email');

    // Privatperson toggle
    if (privateCheckbox) {
      privateCheckbox.addEventListener('change', function () {
        const p = privateCheckbox.checked;
        setFieldDisabled('reg-firma-wrap',       firmaInput,      p);
        setFieldDisabled('reg-firma-email-wrap', firmaEmailInput, p);
        setFieldDisabled('reg-uid-wrap',         uidInput,        p);
        // Optional B2B-only billing/order-confirmation emails — never required.
        setOptionalFieldDisabled('reg-rechnung-email-wrap', rechnungInput, p);
        setOptionalFieldDisabled('reg-ab-email-wrap',       abInput,       p);
        // Firmen-Hinweis im Vorteils-Text ausblenden, wenn Privatperson.
        var benefit = document.getElementById('reg-benefit-verify');
        if (benefit) benefit.style.display = p ? 'none' : '';
        if (p) setUidError('');
      });
    }

    // UID on-blur duplicate check
    if (uidInput) {
      uidInput.addEventListener('blur', function () {
        if (privateCheckbox && privateCheckbox.checked) return;
        const uid = uidInput.value.trim();
        if (!uid) return;
        const email = emailInput ? emailInput.value.trim() : '';
        const url = API_BASE + '/api/b2b/check-uid?uid=' + encodeURIComponent(uid)
          + (email ? '&email=' + encodeURIComponent(email) : '');
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.exists && !data.stub) {
              setUidError(window.customStrings.uidExists);
            } else {
              setUidError('');
            }
          })
          .catch(function () { /* ignore network errors on blur check */ });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const isPrivate = privateCheckbox ? privateCheckbox.checked : false;

      // Client-side required check (firma + uid only if not Privatperson)
      const required = isPrivate
        ? ['vorname', 'nachname', 'email', 'passwort', 'passwort2', 'telefon', 'strasse', 'hausnummer', 'plz', 'ort', 'land']
        : ['firma', 'uid', 'vorname', 'nachname', 'email', 'passwort', 'passwort2', 'telefon', 'strasse', 'hausnummer', 'plz', 'ort', 'land'];

      for (const name of required) {
        const field = form.querySelector('[name="' + name + '"]');
        if (!field || !field.value.trim()) {
          showMessage(window.customStrings.fillRequired, 'error');
          if (field) field.focus();
          return;
        }
      }

      // Email format check
      const emailVal = form.querySelector('[name="email"]').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        showMessage(window.customStrings.validEmail, 'error');
        return;
      }

      // UID duplicate check blocked?
      const uidErr = document.getElementById('reg-uid-error');
      if (!isPrivate && uidErr && uidErr.style.display === 'block' && uidErr.textContent) {
        showMessage(uidErr.textContent, 'error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = window.customStrings.sending;

      // Build payload
      // Password validation
      const pwVal  = (form.querySelector('[name="passwort"]')  || {}).value || '';
      const pw2Val = (form.querySelector('[name="passwort2"]') || {}).value || '';
      if (pwVal.length < 8) {
        showMessage('Das Passwort muss mindestens 8 Zeichen haben.', 'error');
        return;
      }
      if (pwVal !== pw2Val) {
        showMessage(window.customStrings.pwMismatch, 'error');
        return;
      }

      const allFields = ['firma', 'firma_email', 'rechnung_email', 'auftragsbestaetigung_email', 'uid', 'vorname', 'nachname', 'email', 'passwort', 'passwort2', 'telefon', 'strasse', 'hausnummer', 'plz', 'ort', 'land', 'lieferhinweis'];
      const payload = { is_private: isPrivate };
      allFields.forEach(function (name) {
        const f = form.querySelector('[name="' + name + '"]');
        payload[name] = f ? f.value.trim() : '';
      });
      const newsletter = form.querySelector('[name="newsletter"]');
      payload.newsletter = newsletter ? newsletter.checked : true;

      fetch(API_BASE + '/api/b2b/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().then(function (data) { return { status: r.status, data: data }; });
        })
        .then(function (res) {
          if (res.status === 201) {
            // GA4/LinkedIn 2026-08-26: Registrierung erfolgreich. In try/catch — ein
            // Trackingfehler darf nie eine Registrierung kosten.
            try { (window.dataLayer = window.dataLayer || []).push({ event: 'sign_up', method: 'b2b_registration' }); } catch (e) {}
            form.style.display = 'none';
            showMessage(
              res.data.message || window.customStrings.registerSuccess,
              'success'
            );
          } else if (res.status === 409) {
            if (res.data && res.data.code === 'company_already_registered') {
              // Firma hat schon ein Konto → Meldung + CTA statt reinem Fehler.
              showCompanyExistsCTA(payload);
            } else {
              showMessage(res.data.error || 'Ein Konto mit dieser E-Mail-Adresse oder UID existiert bereits.', 'error');
            }
            submitBtn.disabled = false;
            submitBtn.textContent = window.customStrings.createAccount;
          } else {
            showMessage(res.data.error || window.customStrings.registerFailed, 'error');
            submitBtn.disabled = false;
            submitBtn.textContent = window.customStrings.createAccount;
          }
        })
        .catch(function () {
          showMessage(window.customStrings.net2, 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = window.customStrings.createAccount;
        });
    });
  });
})();
